import { FC, useState } from 'react';
import NearVanModal from '../NearVanModal';
import DeleteModalForm from 'src/components/Items/DeleteModalForm';
import FormIcon from 'src/components/Items/ActionForm/FormIcon';
import { dineroFormat } from 'src/common/utils/dataFormat';
import { INearVanFetch } from 'src/models/INearVan';
import Icons from 'src/common/icons';

interface IProps {
  nearVan: INearVanFetch;
  homeLocation: string;
  existLocations: string[];
}

const LocationsNearbyItem: FC<IProps> = ({ nearVan, homeLocation, existLocations }) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <>
      <div className='nearby-locations__item'>
        <div className='nearby-locations__item__location' onClick={() => setOpenEdit(true)}>
          {nearVan.location}
        </div>
        <div className='nearby-locations__item__price'>
          {dineroFormat(nearVan.price, nearVan.currency)}
          <FormIcon
            icon={<Icons.Delete classes='icon_stroke' />}
            handleClick={() => setOpenDelete(true)}
            title={'Delete location nearby'}
          />
        </div>
      </div>
      <DeleteModalForm
        id={nearVan.id}
        type='location nearby'
        handleClose={() => setOpenDelete(false)}
        open={openDelete}
      />
      <NearVanModal
        vanId={nearVan.van_id}
        nearVan={nearVan}
        homeLocation={homeLocation}
        existLocations={existLocations}
        close={openEdit}
        handleClose={() => setOpenEdit(false)}
      />
    </>
  );
};
export default LocationsNearbyItem;
